import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-popup-export-payroll-confirm',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './popup-export-payroll-confirm.component.html',
    styleUrls: ['./popup-export-payroll-confirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupExportPayrollConfirmComponent {
  constructor(
    private dialogRef: MatDialogRef<PopupExportPayrollConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { count: number | null }
  ) {}

  close(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
